let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5OJft")).then(() => parcelRequire('6NdgQ'));